// extracted by mini-css-extract-plugin
export default {"root":"Size__root--25hBM","size":"Size__size--GpkRH","inline":"Size__inline--19uHC","icon":"Size__icon--EkVhB","delete":"Size__delete--2rUcz"};